import SoundManager from "../../../../../lib/html5-software-library/src/ranj/audio/SoundManager";
import RevisableLanguagePack from "../../../../../lib/html5-software-library/src/ranj/language/RevisableLanguagePack";
import MediatorManager from "../../../core/application/MediatorManager";
import AbstractMediator from "../../../core/ui/AbstractMediator";
import SkinFactory from "../../../core/ui/SkinFactory";
import EmailInteractionEvent from "../controller/EmailInteractionEvent";
import EmailAddedEvent from "../model/EmailAddedEvent";
import EmailModel from "../model/EmailModel";
import ScrollPane from "../../../../../lib/html5-software-library/src/ranj/components/scrolling/ScrollPane";
import Rectangle from "../../../../../lib/html5-software-library/src/ranj/geom/Rectangle";
import { isNull } from "../../../../../lib/html5-software-library/src/ranj/util/TypeUtil";

export default class EmailConversationListMediator extends AbstractMediator {
    /**
     * @constructor
     * @param {createjs.MovieClip} target 
     * @param {soma.EventDispatcher} dispatcher 
     * @param {EmailModel} emailModel 
     * @param {RevisableLanguagePack} languagePack 
     * @param {MediatorManager} mediatorManager 
     * @param {SoundManager} soundManager
     */
    constructor(target, dispatcher, emailModel, languagePack, mediatorManager, soundManager) {
        super(target, dispatcher);

        this._emailModel = emailModel;
        this._languagePack = languagePack;
        this._mediatorManager = mediatorManager;
        this._soundManager = soundManager;

        this._indicatorButtonsMediators = [];

        this._boxType = this.getCustomData().boxType;
        this._skinKeyRegistry = this.getCustomData().skinKeyRegistry;
        this._smallNpcImages = this.getCustomData().smallNpcImages;
    }

    initialize() {
        super.initialize();

        this._indicatorClickFunction = this._handleIndicatorButtonClick.bind(this);

        this._target.emptyIndicationTextField.text = this._languagePack.getText('email.noConversations');

        const scrollPaneViewport = new Rectangle(0, 0, this._target.nominalBounds.width, this._target.nominalBounds.height);
        const halvedDragButtonHeight = this._target.vScrollBar.dragButton.nominalBounds.height * .5;
        this._scrollPane = new ScrollPane(scrollPaneViewport, null, this._target.vScrollBar, this._target.contentContainer, this._target.contentMask, true, null, halvedDragButtonHeight);

        this._updateIndicationButtons();

        this.registerEventListener(EmailAddedEvent.EMAIL_ADDED_TO_CONVERSATION, this._updateIndicationButtons.bind(this));
    }

    destroy() {
        this._destroyIndicatorButtons();

        if (!isNull(this._scrollPane)) {
            this._scrollPane.setScrollPosition(0, 0);
            this._scrollPane.destroy();
            this._scrollPane = null;
        }

        super.destroy();
    }

    setBoxType(value) {
        this._boxType = value;

        this._updateIndicationButtons();
    }

    _updateIndicationButtons() {
        this._destroyIndicatorButtons();

        const convos = this._emailModel.getConversationsForBoxType(this._boxType);
        for (let i = 0; i < convos.length; i++) {
            this._addConversation(convos[i]);
        }

        this._target.emptyIndicationTextField.visible = convos.length === 0;

        this._scrollPane.setScrollPosition(0, 0);
    }

    _destroyIndicatorButtons() {
        for (let i = 0; i < this._indicatorButtonsMediators.length; i++) {
            const indicatorButtonMediator = this._indicatorButtonsMediators[i];
            this._removeIndicatorButtonListeners(indicatorButtonMediator.skin);
            if (indicatorButtonMediator.skin.parent) {
                indicatorButtonMediator.skin.parent.removeChild(indicatorButtonMediator.skin);
            }

            indicatorButtonMediator.destroy();
        }

        this._indicatorButtonsMediators = [];

        this._scrollPane.setScrollPosition(0, 0);
    }

    _addConversation(conversation) {
        const indicatorButtonSkin = SkinFactory.getSkin(this._skinKeyRegistry.EMAIL_INDICATOR_BUTTON);
        indicatorButtonSkin.customData = {
            smallNpcImages: this._smallNpcImages
        };

        indicatorButtonSkin.conversation = conversation;

        this._target.contentContainer.addChild(indicatorButtonSkin);

        const indicatorButtonMediator = this._mediatorManager.createMediator(indicatorButtonSkin, indicatorButtonSkin.skinType);
        this._indicatorButtonsMediators.unshift(indicatorButtonMediator);

        this._addIndicatorButtonListeners(indicatorButtonSkin);
        this._updateIndicatorButtonLayout();
    }

    _updateIndicatorButtonLayout() {
        let y = 0;
        let height = 0;
        for (let index = 0; index < this._indicatorButtonsMediators.length; index++) {
            const indicatorButtonSkin = this._indicatorButtonsMediators[index].skin;
            indicatorButtonSkin.y = y;
            y += Math.round(indicatorButtonSkin.nominalBounds.height + 0);
            y += 1;
            height = y;
        }
        this._scrollPane.update();
        this._scrollPane.setHeightBound(height);
    }

    _handleIndicatorButtonClick({ currentTarget }) {
        const indicatorButton = currentTarget;

        this.dispatch(EmailInteractionEvent.OPEN_CONVERSATION, { conversation: indicatorButton.conversation });
    }

    _addIndicatorButtonListeners(buttonSkin) {
        buttonSkin.addEventListener('click', this._indicatorClickFunction);
    }

    _removeIndicatorButtonListeners(buttonSkin) {
        buttonSkin.removeEventListener('click', this._indicatorClickFunction);
    }
}